module.exports = __webpack_public_path__ + "static/media/whatsapp.f7647e00.svg";